import { lazy } from 'react'
import { Navigate } from 'react-router-dom'
import ComponentLoader from './component-loader'
import SignUp from 'screens/auth/signup'

const Login = ComponentLoader(lazy(() => import('screens/auth/login')))
const ChangePass = ComponentLoader(
  lazy(() => import('screens/auth/changepass/email'))
)
const Pass = ComponentLoader(
  lazy(() => import('screens/auth/changepass/newpass'))
)

const AuthRoutes = [
  {
    path: '',
    children: [
      {
        path: 'login',
        index: true,
        element: <Login />,
      },
      // {
      //   path: 'signup',
      //   index: true,
      //   element: <SignUp />,
      // },
      {
        path: 'forget-pass',
        children: [
          {
            path: '',
            index: true,
            element: <ChangePass />,
          },
          {
            path: 'reset-pass',
            element: <Pass />,
          },
        ],
      },
      {
        path: '',
        element: <Navigate replace to={'./login'} />,
      },
      {
        path: '*',
        element: <Navigate replace to={'./login'} />,
      },
    ],
  },
]

export default AuthRoutes
